import React from 'react';

const Notification = ({ message, type }) => {
  if (!message) return null;

  return (
    <div
      className={`${
        type === 'error' ? 'bg-red-500' : 'bg-green-500'
      } text-white p-4 rounded-lg mb-4`}
    >
      {message}
    </div>
  );
};

export default Notification;
